export default "__VITE_ASSET__ChjOzTUU__"